import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  width: 60rem;
  height: 38rem;
  background-color: white;
`;

export const LeftSide = styled.div`
  display: flex;
  flex-direction: column;
  width: 53%;
  border-right: solid 2px #eff1f5;
  padding-left: 3rem;
  padding-right: 3rem;
`;

export const TitleSlot = styled.div`
  margin-top: 2rem;
  display: flex;
  align-items: center;
  span {
    margin-left: 0.92rem;
    font-family: "Sora";
    font-style: normal;
    font-weight: 600;
    font-size: 1.2rem;
    line-height: 1.5rem;
  }
`;

export const SubTitle = styled.span`
  font-family: "Sora";
  font-style: normal;
  font-weight: 400;
  font-size: 0.8rem;
  line-height: 1rem;
  margin-top: 0.8rem;
  margin-bottom: 0.8rem;
  color: #7e858f;
`;

export const Responsible = styled.span`
  font-family: "Sora";
  font-style: normal;
  font-weight: 600;
  font-size: 0.8rem;
  line-height: 1rem;
  margin-top: 1.5rem;
  color: #585e66;
`;

export const ResponsibleSlot = styled.div`
  display: flex;
  align-items: center;
  margin-top: 0.6rem;

  span {
    margin-left: 0.6rem;
    font-weight: 600;
    font-size: 0.8rem;
    line-height: 1rem;
    color: #42464c;
  }
`;
export const PlaceHolder = styled.div`
  width: 2rem;
  height: 2rem;
  border-radius: 100%;
  background-color: blueviolet;
`;

export const RightSide = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 47%;
  height: 100%;

  span {
    &.right-title {
      width: 85%;
      margin-top: 2rem;
      font-family: "Sora";
      font-style: normal;
      font-weight: 600;
      font-size: 0.95rem;
      line-height: 1.2rem;
      color: #212326;
    }

    &.sub-title {
      width: 85%;
      margin-top: 1rem;
      font-family: "Sora";
      font-style: normal;
      font-weight: 400;
      font-size: 0.8rem;
      line-height: 1rem;
      color: #7e858f;
    }
  }
`;
export const InputSlot = styled.div`
  width: 85%;
  margin-top: 1rem;
  margin-bottom: 0.75rem;
`;

export const RightBody = styled.div`
  position: relative;
  height: 50rem;
  width: 100%;
  overflow-y: scroll;
  display: flex;
  flex-direction: column;
  align-items: center;
  ::-webkit-scrollbar {
    width: 0.3rem;
    background: #cff8e7;
    border-top: 1.41135px solid #40e5a0;
    border-radius: 8.46812px;
  }

  ::-webkit-scrollbar-thumb {
    background: #118052;
    border-radius: 12px;
  }
`;

export const RightFooter = styled.div`
  width: 85%;
  margin-top: 1rem;
  height: 4.8rem;
  padding-bottom: 2rem;
  display: flex;
  flex-direction: row-reverse;

  button:nth-child(1) {
    margin-left: 0.8rem;
    margin-right: 0.4rem;
  }
`;

export const InputDiv = styled.div`
  margin-top: 1rem;
  margin-bottom: 1rem;
`;

export const DataSlot = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 1.5rem;
`;

export const DataDiv = styled.div`
  display: flex;
  flex-direction: column;
  width: 11.75rem;

  span {
    font-family: "Sora";
    font-style: normal;
    font-weight: 600;
    font-size: 0.7062rem;
    line-height: 0.875rem;
    color: #585e66;
    margin-bottom: 0.3608rem;
  }

  span:nth-child(2) {
    user-select: none;
    height: 2.5rem;
    width: 11.75rem;
    padding-left: 1rem;
    padding-right: 1rem;
    border: 2px solid #d4d6da;
    border-radius: 8.47434px;
    background-color: #eff1f5;

    display: flex;
    align-items: center;
    color: #7e858f;
    font-family: "Sora";
    font-style: normal;
    font-weight: 400;
    font-size: 0.8rem;
    line-height: 1rem;
  }

  input {
    height: 2.5rem;
    width: 11.75rem;
    padding-left: 1rem;
    padding-right: 1rem;
    border: 2px solid #d4d6da;
    border-radius: 8.47434px;
    outline: none;
    cursor: pointer;
    user-select: none;

    background-color: #ffffff;

    font-family: "Sora";
    font-style: normal;
    font-weight: 400;
    font-size: 0.8rem;
    line-height: 1rem;
  }
`;

export const TaskDescription = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 1rem;

  span {
    font-family: "Sora";
    font-style: normal;
    font-weight: 600;
    font-size: 0.7062rem;
    line-height: 0.875rem;
    color: #585e66;
    margin-bottom: 0.3608rem;
  }

  textarea {
    min-height: 10rem;
    border: ${({ error }) =>
      error ? " 2px solid #eb5757" : "2px solid #d4d6da"};
    border-radius: 8.47434px;
    outline: none;
    resize: none;

    padding: 0.5rem 0.75rem;
  }
`;
export const Counter = styled.span`
  margin-top: 0.5rem;
  margin-right: 0.2rem;

  font-family: "Sora";
  font-style: normal;
  font-weight: 400;
  font-size: 0.8rem;
  line-height: 0.95rem;
  text-align: right;

  color: #585e66;
`;

export const BoxLoader = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
`;
